module.exports = __webpack_public_path__ + "cfdd7f7c12a9b8d32e378f8b49e3e2b3.svg";